<div class="schema-editabletable-data" *ngIf="loadTable">
    <nz-table #basicTable [nzData]="data" [nzSimple]="false" [nzFrontPagination]="false" [nzShowPagination]="false" [nzSize]="rowSize">
        <thead (nzSortChange)="sort($event)" nzSingleSort>
            <tr>
                <ng-container *ngFor="let col of columns">
                    
                    <th *ngIf="col.sort; else defaultHeader" nzShowSort nzColumnKey="{{col.key}}">
                        {{col.title}}
                    </th>
                    <ng-template #defaultHeader>
                        <th
                        [nzFilters]="listOfStatus"
                        (nzFilterChange)="filter($event)">{{col.title}}</th>
                    </ng-template>
  
                </ng-container>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let dt of basicTable.data; index as i">              
                <ng-container *ngFor="let col of columns;" class="editable-row">
                    <td *ngIf="col.type==='link' && col.title!='View'; else editTpl">{{dt[col.key]}} </td>
                    <td *ngIf="col.title==='View'">
                        <a href="javascript:;" (click)="onView(dt.id)" nz-tooltip nzTitle="View" class="mr-sm"> <i nz-icon type="file"></i></a>
                     </td>
                    <td *ngIf="col.title==='Action' && col.enum && col.enum.length" nzRight="0px">
                            <a nz-button nz-dropdown [nzDropdownMenu]="menu">
                                <i nz-icon nzType="more" nzTheme="outline"></i>
                            </a>
                            <nz-dropdown-menu #menu="nzDropdownMenu">
                                <ul nz-menu nzSelectable>
                                <li nz-tooltip nz-menu-item *ngFor="let act of col.enum" style="width:10em;">
                                    <a (click)="onAction(dt.id, act.value)">
                                        <i nz-icon [type]="actionIcons[act.value]" nzTheme="outline"></i>
                                        <span style="width:10px;"></span>
                                        {{act.text}}
                                    </a>
                                </li>
                            </ul>
                            </nz-dropdown-menu> 
                    </td>
                    <ng-template #editTpl>
                        <td *ngIf="editId !== dt.id && col.title!='View' && col.title!='Action'" (click)="startEdit(dt.id, $event)">{{ dt[col.key] }}</td>
                        <td *ngIf="editId == dt.id && col.title!='View' && col.title!='Action'"> <input type="text" nz-input [(ngModel)]="dt[col.key]" /></td>
                    </ng-template>
                </ng-container>
            </tr>
        </tbody>
    </nz-table>
    <br />
  
    <nz-pagination style="float: right;" [nzPageIndex]="page" [nzTotal]="count" (nzPageIndexChange)="onPageChanged.emit($event)"></nz-pagination>
  </div>
  